module.exports = __webpack_public_path__ + "media/public/img/getyourguide-review-widget-02-2e96f738f16be16b984bc5f0f545ff43.svg";